import { useQuery } from "react-query";
import { QK } from "../base/qk";
import { fetchClient } from "../api/services/Client";

const useClientDetails = (clientID) => {
  const {
    data: clientDetails,
    isLoading,
    error,
  } = useQuery(
    [QK.clientDetails, clientID],
    () => fetchClient(clientID),
    {
      enabled: !!clientID,
    }
  );

  const fullName = clientDetails
    ? [
        clientDetails.first_name,
        clientDetails.middle_name,
        clientDetails.last_name,
      ]
        .filter(Boolean)
        .join(" ")
    : "";

  const NhsNumber = clientDetails?.nhs_number || null;
  const birthDate = clientDetails?.birthdate || null;
  const areaName = clientDetails?.area_name || null;
  const profilePhoto = clientDetails?.profile_photo || null;
  const ageDisplay = clientDetails?.age_display || "N/A";
  const gender = clientDetails?.gender || null;
  const status = clientDetails?.status || null;
  const phoneNumber = clientDetails?.phone_number || null;
  const email = clientDetails?.primary_email || null;

  return {
    clientDetails,
    fullName,
    NhsNumber,
    birthDate,
    areaName,
    profilePhoto,
    ageDisplay,
    gender,
    status,
    phoneNumber,
    email,
    isLoading,
    error,
  };
};

export default useClientDetails;